(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/payment/assets/javascripts/api/jupiter/numbergames/pay.js') >= 0) return;  svs.modules.push('/components/tur/payment/assets/javascripts/api/jupiter/numbergames/pay.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  DIALOG_ACCOUNT_LOW_CANCEL
} = svs.tur.payment.constants.events;
const {
  isProductFamily,
  isSameProduct,
  getProductName,
  getProductNumeric,
  getProductDrawId
} = svs.numbergames.productMapping;
class PayNumbergame extends svs.tur.payment.api.jupiter.base.PayBase {
  constructor(_ref) {
    let {
      wagerModel,
      alwaysPayable,
      draw = svs.numbergames.game.draw
    } = _ref;
    super({
      wagerModel
    });
    this.wagerModel = wagerModel;
    this.productName = wagerModel.get('productId');
    this.price = wagerModel.get('price');
    this.isProlonged = wagerModel.get('isProlonged');
    this.payableObj = wagerModel.toAPIJSON();
    this.alwaysPayable = alwaysPayable;
    this.draw = draw;
    this.onCancel = () => this.trigger(DIALOG_ACCOUNT_LOW_CANCEL);
    if (wagerModel.has('selectedDays') && wagerModel.get('selectedDays').length) {
      wagerModel.get('selectedDays').forEach(day => this.fetchUrls.push("/draw/1/".concat(getProductDrawId(day), "/draws")));
    } else {
      this.fetchUrls.push("/draw/1/".concat(getProductDrawId(wagerModel.get('productId')), "/draws"));
    }
  }
  initialize() {
    const wagerArray = Array.isArray(this.payableObj) ? this.payableObj : [this.payableObj];
    if (wagerArray.some(betsObj => betsObj.bets.some(bet => bet.drawNum === null))) {
      svs.tur.apierrors.showErrorMessage({
        response: 8105
      });
      return;
    }
    super.initialize();
  }
  onAccountStatusSuccess() {
    if (this.wasDrawOpenedToday()) {
      this.showPlayingNextDrawDialog({
        onConfirm: () => {
          super.onAccountStatusSuccess();
        }
      });
    } else if (this.isDrawClosedButPayable()) {
      this.fetchNextDraw({
        drawProduct: getProductDrawId(this.productName),
        drawNumber: this.draw.nextDrawNumber,
        onSuccess: draw => {
          const DrawClass = svs.numbergames.draws["".concat(getProductName(this.productName), "Draw")];
          this.draw = new DrawClass(draw);
          this.showPlayingNextDrawDialog({
            onConfirm: () => {
              super.onAccountStatusSuccess();
            }
          });
        },
        onError: () => {
          super.onAccountStatusSuccess();
        }
      });
    } else {
      super.onAccountStatusSuccess();
    }
  }
  wasDrawOpenedToday() {
    const openedItsId = this.draw.wasOpenedToday;
    if (openedItsId && isProductFamily(this.productName)) {
      return this.wagerModel.get('selectedDays').some(day => isSameProduct(day, openedItsId));
    }
    return Boolean(openedItsId);
  }
  isDrawClosedButPayable() {
    return !this.draw.drawNumber && this.draw.nextDrawNumber && this.alwaysPayable;
  }

  fetchNextDraw(_ref2) {
    let {
      drawProduct,
      drawNumber,
      onSuccess,
      onError
    } = _ref2;
    const path = "/draw/1/".concat(drawProduct, "/draws/").concat(drawNumber);
    svs.core.jupiter.call({
      method: 'GET',
      path
    }, _ref3 => {
      let {
        draw
      } = _ref3;
      onSuccess(draw);
    }, error => {
      svs.tur.payment.logger.warn("Request to ".concat(path, " responded with error!"), error);
      onError(error);
    });
  }
  promptNextDraw(_ref4) {
    let {
      nextDrawDate,
      upcomingDrawProduct
    } = _ref4;
    this.payableObj = this.wagerModel.toAPIJSON();
    new svs.tur.payment.api.jupiter.numbergames.dialogs.PaymentConfirmNextDraw(_objectSpread({
      nextDrawDate,
      upcomingDrawProduct,
      onConfirm: () => {
        this.onPayConfirm();
      },
      onCancel: () => {
        this.onPayCancel();
      }
    }, this.getConfirmDialogProps()));
  }
  showPlayingNextDrawDialog(_ref5) {
    let {
      onConfirm
    } = _ref5;
    const currentDraw = isProductFamily(this.productName) ? this.draw[this.draw.wasOpenedToday] : this.draw;
    new svs.tur.payment.dialogs.PlayingNextDraw({
      productNumeric: getProductNumeric(this.productName),
      regCloseTime: currentDraw.closeTime,
      onCancel: () => {
        this.destroy();
      },
      onConfirm
    });
  }
  showSuccessDialog() {
    new svs.tur.payment.api.jupiter.numbergames.dialogs.PaymentSuccess({
      onConfirm: () => {
        new svs.tur.CorrectionEmail({
          productName: getProductName(this.wagerModel.get('productId')),
          wagerCost: this.wagerModel.get('price'),
          callback: () => {
            this.onSuccessDialogConfirm();
          }
        }).show();
      }
    });
  }
}
svs.tur.payment.api.jupiter.numbergames.Pay = PayNumbergame;

 })(window);